export const readInputValueForPublicKey = () => {
  const inputIdForBiometricResult = "webAuthnOutcome";
  return (document.getElementById(inputIdForBiometricResult) as HTMLInputElement)?.value || "";
};

export const setBiometricPublicKeyValue = (successResponse: any) => {
  let inputIdForBiometricResult = "webAuthnOutcome";
  const requestBody = JSON.parse(JSON.stringify(successResponse));
  const hiddenValueCallback = requestBody?.callbacks?.find((cb: any) => cb.type === "HiddenValueCallback");
  if (hiddenValueCallback && hiddenValueCallback?.input[0].value) {
    inputIdForBiometricResult = hiddenValueCallback.input[0].value;
    hiddenValueCallback.input[0].value = readInputValueForPublicKey();
  }

  return requestBody;
};

export const buildPublicKey = (successResponse: any): Promise<any> => {
  return new Promise((res, rej) => {
    const requestBody = JSON.parse(JSON.stringify(successResponse));
    requestBody.stage = "Scripted2";
    const textOutputCallback = requestBody?.callbacks?.find((cb: any) => cb.type === "TextOutputCallback");
    const hiddenValueCallback = requestBody?.callbacks?.find((cb: any) => cb.type === "HiddenValueCallback");

    try {
      // Dynamically set the relying party ID to the current domain
      const currentDomain = window.location.hostname;
      const scriptContent = textOutputCallback?.output[0].value.replace(
        /rp: {\s*id: "[^"]+"/,
        `rp: { id: "${currentDomain}"`
      );
      eval(scriptContent);
      eval(textOutputCallback[1]?.output[0].value);
    } catch (e) {
      rej(e);
    }

    setTimeout(() => {
      const clientScriptOutputData = document.getElementById("clientScriptOutputData") as HTMLInputElement;
      if (clientScriptOutputData) {
        hiddenValueCallback.input[0].value = clientScriptOutputData.value;
      }
      const webAuthnOutcomeElement = document.getElementById("webAuthnOutcome") as HTMLInputElement;
      const webAuthnOutcomeValue = webAuthnOutcomeElement ? webAuthnOutcomeElement.value : null;
      res(requestBody);
    }, 40);
  });
};

export const createInputPlaceholderForBiometric = (successResponse: any) => {
  let inputIdForBiometricValue = "webAuthnOutcome";

  const hiddenValueCallback = successResponse?.callbacks?.find((cb: any) => cb.type === "HiddenValueCallback");

  if (hiddenValueCallback && hiddenValueCallback?.input[0].value) {
    inputIdForBiometricValue = hiddenValueCallback.input[0].value;
  }

  if (document.getElementById(inputIdForBiometricValue)) {
    return;
  }

  const biometric_placeholder_element = document.getElementById("biometric_placeholder");
  if (biometric_placeholder_element) {
    const input = document.createElement("input");
    input.id = inputIdForBiometricValue;
    input.type = "text";
    biometric_placeholder_element.appendChild(input);
  }
  const webAuthnOutcomeElement = document.getElementById("webAuthnOutcome") as HTMLInputElement;
  const webAuthnOutcomeValue = webAuthnOutcomeElement ? webAuthnOutcomeElement.value : null;
};
